import bg_patrolShop from "../images/page_bg_patrolShop.png";
import bg_storeVisit from "../images/page_bg_storeVisit.png";
import bg_aiDetection from "../images/page_bg_aiDetection.png";
import bg_smartAds from "../images/page_bg_smartAds.png";
// import bg_smartOA from "../images/page_bg_smartOA.png";
import bg_videoTracing from "../images/page_bg_videoTracing.png";
import bg_peopleCount from "../images/page_bg_peopleCount.png";
import bg_dataCenter from "../images/page_bg_dataCenter.png";
// import bg_onlineDrainage from "../images/page_bg_onlineDrainage.png";
import bg_motivateGrowth from "../images/page_bg_motivateGrowth.png";
import bg_establishment from "../images/page_bg_establishment.png";
import bg_investment from "../images/page_bg_investment.png";

import peopleCount_preview from "../images/peopleCount_preview.png";

export const commonInfo = {
  patrolShop: {
    title: "高效巡店",
    title_bg: bg_patrolShop,
    bgColor: "#000",
    img: "partrolShop_banner_20220118",
    qsTitle: "主要解决门店越多、运营管理越难的几个问题：",
    qs: [
      "总部与一线脱节",
      "巡店效率上不来，费用下不去",
      "门店执行力良莠不齐",
      "各级、各专业线标准不一，或无标准",
      "巡店数据应用难",
      "安防监控形同虚设",
    ],
    preview_video:
      "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_patrolShop_preview_1_20250619.mp4",

    videoList: [
      {
        title: "视频/远程巡店",
        describe:
          "通过手机或PC端进行远程视频巡店，发现问题-整改-复检全部线上闭环。",
        poster:
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_patrolShop_1_poster_202303.png",
        list: [
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_patrolShop_1_202303.mp4",
        ],
      },
      {
        title: "现场巡店",
        describe:
          "打破传统纸质化巡店模式，将企业标准导入系统，督导用手机即可完成日常检查，检查结束即生成巡店报表。",
        poster:
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_patrolShop_2_poster_202303.png",
        list: [
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_patrolShop_2_202303.mp4",
        ],
      },
      {
        title: "AI巡店",
        describe:
          "通过AI智能算法实现自动化检测-分析-告警，标准化、重复性工作效率数字化倍增。",
        poster:
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_patrolShop_3_poster_20250620.png",
        list: [
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_patrolShop_3_202303.mp4",
        ],
      },
      {
        title: "AI门店助手",
        describe:
          "AI自动诊断门店视频截图中陈列、人员操作等场景合规性，实时生成异常清单并下发整改工单，全流程自动化。",
        poster:
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_patrolShop_4_poster_20250620.png",
        list: [
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_patrolShop_preview_2_20250619.mp4",
        ],
      },
    ],
  },
  storeVisit: {
    title: "神秘顾客",
    title_bg: bg_storeVisit,
    bgColor: "#FFD93B",
    describe: `
      零售连锁企业派单式巡店新模式<br>
      专业的神秘顾客探店平台<br>
      从顾客角度发现门店真实运营问题<br>
      降低企业巡店成本<br>
      精细化提升门店管理`,
    preview_video:
      "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_storeVisit_promote.m4v",
    starList: [
      "提供不同行业标准化探店模板",
      "全国资深零售从业人员专业探店",
      "支持定向派发探店任务",
      "AI智能比对高效验证探店报告",
      "平台多重筛选，保障报告质量",
      "行业专家结合探店数据指导运营优化",
      "与万店掌平台数据互通，巡店结果双向对比",
    ],
  },
  aiDetection: {
    title: "AI识别",
    title_bg: bg_aiDetection,
    bgColor: "#13193F",
    describe:
      "利用AI智能算法实现门店标准场景自动化识别检测-分析-告警的闭环流程，着装、老鼠、杂物、行为等动静态场景快速捕捉检测，提升人效的同时落地门店强管控机制，保障门店消费体验感。",
    typeVideoList: [
      {
        type: "通用场景",
        value: "general",
        videoList: [
          {
            title: "门店规范",
            describe:
              "门店日常通用场景的标准化落地，实现24小时自动化检测，如口罩、工服、工帽、过道杂物等。",
            poster:
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_ai_1_poster_20250620.png",
            list: [
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_ai_video_1_20250620.mp4",
            ],
          },
          {
            title: "玩手机/吸烟",
            describe:
              "规范员工标准工作状态，提升员工专业服务素养，保障品牌形象。",
            poster:
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_ai_2_poster_20250620.png",
            list: [
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_ai_video_2_20250620.mp4",
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_ai_video_3_20250620.mp4",
            ],
          },
          {
            title: "收银防损",
            describe:
              "规范门店标准收银场景，如现金交易、扫码交易、POS交易等，所有交易记录透明化，有迹可循。",
            poster:
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_ai_3_poster_20250620.png",
            list: [
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_ai_video_5_20250620.mp4",
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_ai_video_4_20250620.mp4",
            ],
          },
          {
            title: "队列管理",
            describe:
              "收银区、服务区等区域自动识别等待人数、弃购人数、等待时长、结算时长等关键数据，动态调配店员资源，提升顾客满意度。",
            poster:
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_ai_4_poster_20250620.png",
            list: [
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_ai_video_6_20250620.mp4",
            ],
          },
          {
            title: "空岗/聚众",
            describe:
              "强化员工标准接待规范，确保营业期间的在岗服务，优化顾客体验。",
            poster:
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_ai_5_poster_20250620.png",
            list: [
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_ai_video_7_20250620.mp4",
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_ai_video_8_20250620.mp4",
            ],
          },
          {
            title: "营业时间",
            describe: "定时检查门店标准营业时间，规范门店经营。",
            poster:
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_ai_6_poster_20250620.png",
            list: [
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_ai_video_9_20250620.mp4",
            ],
          },
          {
            title: "例会检测",
            describe: "自动检查门店例会开展情况，远程监管，规范日常工作。",
            poster:
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_ai_7_poster_20250620.png",
            list: [
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_ai_video_10_20250620.mp4",
            ],
          },
          {
            title: "迎宾检测",
            describe:
              "自动检测店员是否在规定区域及顾客过店时进行规范化迎宾，提升进店率和客户体验。",
            poster:
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_ai_8_poster_20250620.png",
            list: [
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_ai_video_11_20250620.mp4",
            ],
          },
          {
            title: "进食检测",
            describe:
              "自动检测门店服务场景，如收银台、接待台等是否有员工进食行为，保障门店服务形象。",
            poster:
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_ai_9_poster_20250620.png",
            list: [
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_ai_video_12_20250620.mp4",
            ],
          },
        ],
      },
      {
        type: "餐饮行业",
        value: "catering",
        videoList: [
          {
            title: "餐饮检测",
            describe:
              "构建从制作到出餐的全流程监管体系，如刀具摆放、出餐时间、出餐标准等标准出餐操作。",
            poster:
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_ai_10_poster_20250620.png",
            list: [
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_ai_video_13_20250620.mp4",
            ],
          },
          {
            title: "餐饮翻台率",
            describe:
              "从顾客入座到离席，自动统计翻台次数、计算空桌时长，实时查看省市下辖门店占用率动态排名、城市排名等，进一步预测高峰时段客流，提升桌位利用率，优化用餐体验。",
            poster:
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_ai_11_poster_20250620.png",
            list: [
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_ai_video_14_20250620.mp4",
            ],
          },
          {
            title: "清台检测",
            describe:
              "自动检测并及时提醒门店清台，减少顾客等待时间，优化消费体验。",
            poster:
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_ai_12_poster_20250620.png",
            list: [
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_ai_video_15_20250620.mp4",
            ],
          },
          {
            title: "后厨报损",
            describe:
              "结合后厨垃圾桶及员工动作，自动识别后厨是否按门店规范进行食物报损，保障食品安全。",
            poster:
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_ai_13_poster_20250620.png",
            list: [
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_ai_video_16_20250620.mp4",
            ],
          },
          {
            title: "老鼠检测",
            describe: "自动检测老鼠并跟踪行动轨迹，优化企业食安风控管理。",
            poster:
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_ai_15_poster_20250620.png",
            list: [
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_ai_video_18_20250620.mp4",
            ],
          },
          {
            title: "明火离人",
            describe:
              "识别场景中是否存在明火及人员离岗的双重危险，及时进行火险预警。",
            poster:
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_ai_14_poster_20250620.png",
            list: [
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_ai_video_17_20250620.mp4",
            ],
          },
        ],
      },
      {
        type: "零售快消",
        value: "fastGoods",
        videoList: [
          {
            title: "陈列饱满度",
            describe:
              "AI实时捕捉并动态优化生鲜商品陈列状态，识别生鲜货架缺货占比与时长等数据，实现缺货预警、陈列规范管理和补货策略优化。",
            poster:
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_ai_16_poster_20250620.png",
            list: [
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_ai_video_19_20250620.mp4",
            ],
          },
          {
            title: "陈列缺货",
            describe:
              "货架检测智能摄像机实时检测货架陈列情况，及时提醒缺货、错放等问题，同时支持一键生成货架陈列标准。",
            poster:
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_ai_17_poster_20250620.png",
            list: [
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_ai_video_20_20250620.mp4",
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_ai_video_21_20250620.mp4",
            ],
          },
          {
            title: "冷柜温控",
            describe:
              "实时检测冷柜温度仪，自动识别异常温度波动，保障食品存储安全。",
            poster:
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_ai_18_poster_20250620.png",
            list: [
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_ai_video_22_20250620.mov",
            ],
          },
          {
            title: "吊旗检测",
            describe: "针对门店促销/宣传吊旗遮挡摄像机检测等情况进行实时告警。",
            poster:
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_ai_19_poster_20250620.png",
            list: [
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_ai_video_23_20250620.mp4",
            ],
          },
          {
            title: "菜叶检测",
            describe:
              "针对生鲜门店场景中，如蔬菜叶子等影响地面清洁和顾客游逛安全的物体识别，保障门店场景整洁。",
            poster:
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_ai_20_poster_20250620.png",
            list: [
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_ai_video_24_20250620.mp4",
            ],
          },
          {
            title: "广告屏检测",
            describe: "自动检测门店广告屏幕是否按要求开启，正常播放宣传素材。",
            poster:
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_ai_21_poster_20250620.png",
            list: [
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_ai_video_25_20250620.mp4",
            ],
          },
          {
            title: "商品识别",
            describe: "识别商品名称、规格等信息，为构建智慧购物奠定底层基础。",
            poster:
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_ai_22_poster_20250620.png",
            list: [
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_ai_video_26_20250620.mp4",
            ],
          },
        ],
      },
      {
        type: "专项检测",
        value: "special",
        videoList: [
          {
            title: "健身房管理",
            describe:
              "针对健身房等会员制门店场景，进行会员尾随、跌倒、私教行为等检测，提升场景规范度和会员体验。",
            poster:
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_ai_23_poster_20250620.png",
            list: [
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_ai_video_29_20250620.mp4",
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_ai_video_28_20250620.mp4",
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_ai_video_27_20250620.mp4",
            ],
          },
          {
            title: "车辆管理",
            describe:
              "停车场24小时自动识别车辆身份，区分“停车进店”的有效客流，帮助优化车位调度，评估商业引流效果。",
            poster:
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_ai_24_poster_20250620.png",
            list: [
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_ai_video_30_20250620.mp4",
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_ai_video_31_20250620.mp4",
            ],
          },
        ],
      },
      {
        type: "AI上线",
        value: "AILine",
        videoList: [
          {
            title: "自主选购",
            describe: "小程序自助选购AI模型并快速关联门店上线AI应用。",
            poster:
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_ai_25_poster_20250620.png",
            list: [
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_ai_video_32_20250620.mp4",
            ],
          },
          {
            title: "自主训练",
            describe: "只需4步，AI模型自主训练并快速上手。",
            poster:
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_ai_26_poster_20250620.png",
            list: [
              "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_ai_video_33_20250620.mp4",
            ],
          },
        ],
      },
    ],
  },
  smartAds: {
    title: "智能信发",
    title_bg: bg_smartAds,
    bgColor: "#000",
    describe:
      "品牌宣传视频、新品推广海报、门店背景音乐等高时效性标准化内容通过信发平台实现总部一键下达，门店同步呈现。",
    preview_video:
      "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_smartAds_preview_202303.mp4",
    videoList: [
      {
        title: "营销设备大屏",
        describe:
          "集中管理所有门店广告设备的看板。实时显示设备是否在线、正在播放什么内容、广告的投放设备数量以及在线数，同时支持不同营销素材快速切换查看。",
        poster:
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/marketing_equipment_large_screen_20250620.png",
        list: [
          "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_smartAds_1_20250620.mp4",
        ],
      },
    ],
  },
  // smartOA: {
  //   title: "远程协同",
  //   title_bg: bg_smartOA,
  //   bgColor: "#0B2F43",
  //   describe:
  //     "连接门店-总部、顾客-门店、供应商-企业等多角色，高效流转，协同工作，所有工作记录线上留痕可追溯。",
  //   videoList: [
  //     {
  //       title: "远程协同",
  //       describe:
  //         "高效协同企业内部各项工作流程，实现线上远程交接班、任务下发、门店分享等。",
  //       poster:
  //         "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_smartOA_1_poster_202303.png",
  //       list: [
  //         "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_smartOA_1_202303.mp4",
  //       ],
  //     },
  //   ],
  // },
  videoTracing: {
    title: "视频追溯",
    title_bg: bg_videoTracing,
    bgColor: "#14232E",
    describe:
      "生产/服务/物流等环节全程视频记录，对接POS、WMS、ERP等门店系统实现自动监测预警，实现企业全局管理的数字化、透明化、精细化。",
    videoList: [
      {
        title: "收银追溯",
        describe:
          "对接企业ERP系统，实现收银数据与实时视频同时呈现，为收银纠纷取证，降低收银损失。",
        poster:
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_videoTracing_1_poster_202303.png",
        list: [
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_videoTracing_1_202303.mp4",
        ],
      },
      {
        title: "异常订单",
        describe:
          "对接企业POS系统，预设异常规则，如有单无人、异常折扣等，自动告警。",
        poster:
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_videoTracing_2_poster_202303.png",
        list: [
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_videoTracing_2_202303.mp4",
        ],
      },
      {
        title: "仓储物流追溯",
        describe:
          "对接企业物流系统，输入物流单号即可查看商品装箱过程，追踪少发/漏发/错发等异常状况。",
        poster:
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_videoTracing_3_poster_202303.png",
        list: [
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_videoTracing_3_202303.mp4",
        ],
      },
      {
        title: "食品溯源",
        describe:
          "输入商品编码，调取生产车间制作场景视频、食品安全证书等，进行食品溯源，提高品牌信任力。",
        poster:
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_videoTracing_4_poster_202303.png",
        list: [
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_videoTracing_4_202303.mp4",
        ],
      },
      {
        title: "商品质量管控",
        describe:
          "通过生鲜大屏及时追踪商品生产日期、保质期、库存量等信息，商品信息实时更新呈现，保障商品质量和库存管控。",
        poster:
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_videoTracing_5_poster_202303.png",
        list: [
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_videoTracing_5_202303.mp4",
        ],
      },
    ],
  },
  peopleCount: {
    title: "客流动线分析",
    title_bg: bg_peopleCount,
    bgColor: "#291A3B",
    describe:
      "进店客流=潜在业绩增量，利用客流分析技术精准掌握门店客流数据、关联销售数据、热度数据等，洞察销售增长/下降原因，快速高效改进门店经营策略。",
    perview_pic: peopleCount_preview,
    videoList: [
      {
        title: "过店客流",
        describe:
          "通过店外客流设备精准统计店外通道经过的客流，结合进店客流数据，提供任意时间段的进店率，同时可进行跨店对比。 ",
        poster:
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_peopleCount_1_poster_202303.png",
        list: [
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_passenger_outDoor_promote_20211203.mp4",
        ],
      },
      {
        title: "精准客流",
        describe:
          "利用客流统计以及人形轮廓、着装等AI识别技术，支持去重并过滤店员、外卖等特定人群，实现精准的进出店客流统计。",
        poster:
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_peopleCount_2_poster_202303.png",
        list: [
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_passenger_accurate_promote_20250620.mp4",
        ],
      },
      {
        title: "客流热点",
        describe:
          "通过安装在门店内的热点客流设备，自动统计每一位进店顾客的行动轨迹，结合门店布局和商品陈列，实现热区分析、商品关注度分析等。",
        poster:
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_peopleCount_3_poster_202303.png",
        list: [
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_passenger_flow_promote_3_202212.mp4",
        ],
      },
      {
        title: "空间占用",
        describe:
          "将多个自定义分割的区域整合到一个视图中，查看全场实时客流，并通过热力图直观了解客流动态，深入分析企业及门店的客流情况。",
        poster:
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_peopleCount_3_poster_20250620.png",
        list: [
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_passenger_outDoor_promote_1_202505620.mp4",
        ],
      },
      {
        title: "客流报表",
        describe:
          "综合门店客流数据，结合门店各项经营数据、天气、节假日等多维度数据进行系统汇总，自动化分析对比门店成交率、提袋率、复购率等关键指标，为经营决策提供数据支撑。",
        poster:
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_peopleCount_4_poster_20250620.png",
        list: [
          "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_passenger_flow_promote_6_20250620.mp4",
        ],
      },
    ],
  },
  dataCenter: {
    title: "数据中心",
    title_bg: bg_dataCenter,
    bgColor: "#0F1240",
    describe:
      "释放数据力量，对企业经营指标进行多维度深度挖掘、拆解、分析、整合等，实时动态组合呈现，为企业战略布局、经营管理、市场决策提供管家式数据支撑。",
    videoList: [
      {
        title: "电视墙系统",
        describe:
          "多屏幕拼接而成超大电视墙，为企业视频监控、智慧会议提供辅助，同时提高企业总部实力形象。",
        poster:
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_dataCenter_1_poster_202303.png",
        list: [
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_videoWall_promote.mp4",
        ],
      },
      {
        title: "商业BI定制",
        describe:
          "轻量级定制化企业智能大屏，将企业经营数据、巡店数据、产品数据等进行可视化整合呈现，支持POS、ERP系统对接。",
        poster:
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_dataCenter_2_poster_202303.png",
        list: [
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_BIScreen_promote.mp4",
        ],
      },
      {
        title: "APP数据中心",
        describe:
          "移动版企业BI系统，对接企业自有和第三方系统数据，在手机端实时整合呈现企业整体经营概况、多维度门店数据对比分析结果、异常告警数据等。",
        poster:
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_dataCenter_3_poster_202303.png",
        isColumn: true,
        list: [
          "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_dataCenter_storeOverview_promote.mp4",
          "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_dataCenter_dataScreening_promote.mp4",
          "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_dataCenter_storeRanking_promote.mp4",
          "https://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_dataCenter_alarmDate_promote.mp4",
        ],
      },
    ],
  },
  // onlineDrainage: {
  //   title: "线上引流",
  //   title_bg: bg_onlineDrainage,
  //   bgColor: "#342B24",
  //   describe:
  //     "专为零售连锁企业打造的私域运营工具，助力实体零售转型线上营销，打通门店-直播-商城-社群链条，实现流量共享，业绩提升。",
  //   preview_video:
  //     "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_onlineDrainage_preview_202303.mp4",
  //   starList: [
  //     `<span>小程序商城</span><span>搭建全渠道销售门店，打破时空限制。</span>`,
  //     `<span>导购管家</span><span>智能导购系统，全面提高销售积极性。</span>`,
  //     `<span>企微助手</span><span>赋能私域精细化运营，促进客户高效转化。</span>`,
  //     `<span>专家带教</span><span>专家团队全程指导，零基础上手门店运营。</span>`,
  //     `<span>数据支持</span><span>门店数据全面解析，高效指导门店经营。</span>`,
  //     `<span>会员管理</span><span>会员全周期管理，多维度提升客户服务。</span>`,
  //   ],
  // },
  motivateGrowth: {
    title: "员工激励与成长",
    title_bg: bg_motivateGrowth,
    bgColor: "#430C0C",
    describe:
      "帮助企业突破人才成长瓶颈，解决各地门店员工集中培养耗时、费力、成本高等问题，优化企业内部晋升机制，有效激励员工提高综合素质，从而为顾客提供多元化、高品质服务。",
    videoList: [
      {
        title: "掌上学院<br>培训体系",
        describe:
          "建立企业个性化人才培养平台，在线完成培训、考核、晋升等，动态关注员工成长曲线，快速选拔优秀人才。",
        poster:
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_motivateGrowth_1_poster_202303.png",
        list: [
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_onlineDrainage_1_202303.mp4",
        ],
      },
      {
        title: "AI培训",
        describe:
          "融合AI大模型，实时业务解答、智能陪练模拟真实场景及自动化试题生成技术，构建“学-练-考”闭环体系。",
        poster:
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/AI_training_20250620.png",
        list: [
          "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_onlineDrainage_2_20250620.mp4",
        ],
      },
    ],
  },
  establishment: {
    title: "开店筹建",
    title_bg: bg_establishment,
    bgColor: "#092E2B",
    describe:
      "可定制的标准开店流程系统。将选址、装修、证照办理等复杂环节拆解为可视化任务节点，多端数据同步与云端文档集中管理，配合智能催办机制，有效规避任务超期风险。",
    preview_video:
      "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_establishment_preview_20250623.mp4",
    tail_images: [
      "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_establishment_1_tail_20250623.png",
    ],
  },
  investment: {
    title: "招商管理",
    title_bg: bg_investment,
    bgColor: "#342B24",
    describe:
      "品牌加盟商全周期数字化管理体系，覆盖从招募、资质审核、面试、签约到选址开发的全流程。有效规避资质不符、选址偏差及合同纠纷等业务痛点，确保全周期合规可控。",
    preview_video:
      "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/videos/wx_investment_preview_20250623.mp4",
    tail_images: [
      "http://ovopark.oss-cn-hangzhou.aliyuncs.com/web/images/wx_investment_1_tail_20250623.png",
    ],
  },
};

export default commonInfo;
